<template>
  <!-- 市区板块内容部分第一块-->
  <div class="box">
    <div class="contentBox">
      <button class="TopListbtn" @mouseenter="ExpressBtnenter()">
        <a-icon type="snippets" /><span>地方快讯</span>
      </button>
      <button class="TopListbtn" @mouseenter="BusinessBtnenter()">
        <a-icon type="container" /><span>经营主体</span>
      </button>

      <button class="TopListbtn" @mouseenter="SupplBtnenter()">
        <a-icon type="video-camera" /><span>供应信息</span>
      </button>

      <button class="TopListbtn" @mouseenter="TechnologyBtnenter()">
        <a-icon type="audit" /><span>科技展翅</span>
      </button>
      <button class="TopListbtn" @mouseenter="NoticeBtnenter()"><a-icon type="audit" /><span>通知公告</span></button>
    </div>
    <!-- 经营主体下的子版块 -->
    <div v-if="btn">
      <button class="smallBtn">
        <span>家庭农场</span>
      </button>
      <button class="smallBtn">
        <span>农民合作社</span>
      </button>
      <button class="smallBtn">
        <span>龙头企业</span>
      </button>
      <button class="smallBtn">
        <span>服务组织</span>
      </button>
    </div>
    <!--地方快讯 -->
    <div v-show="topitem" style="background:#fff;width:100%;height:100%;height:310px;" >
      <a-list bordered :data-source="listData">
        <a-list-item v-for="(item, index) of listData" :key="index" :value="item.title">
          <a @click="TextcontentClick(item.id)" style="color:#000">
            <span style="float:left">{{ item.title }}</span>
          </a>
          <a @click="TextcontentClick(item.id)" style="color:#000">
            <span style="float:right">{{ item.publishTime }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
    <div v-if="citysearchBox & (btnType === '供求信息')">
      <citysearch-Box title="供应信息" SdType="1" style="float:left;background:#ccc;width:49%"></citysearch-Box>
      <citysearch-Box title="求购信息" SdType="2" style="float:right;background:#ccc;width:49%"></citysearch-Box>
      <div style="clear: both"></div>
    </div>
    <div v-else-if="citysearchBox & (btnType === '科技展翅')">
      <citysearch-Box title="农技课堂" infoType="5" orgId="this.$route.query.orgId" style="float:left;background:#ccc;width:49%"></citysearch-Box>
      <citysearch-Box title="庄稼医生" infoType="6" orgId="this.$route.query.orgId" style="float:right;background:#ccc;width:49%"></citysearch-Box>
    </div>
  </div>
</template>
<script>
import citysearchBox from '@/layouts/topBox/cityBox/citysearchBox.vue'
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
export default {
  components: {
    citysearchBox
  },
  data() {
    return {
      oDiv: '',
      colorData: '#e6dfcf',
      btn: false,
      topitem: true,
      citysearchBox: false,
      /**
       * 1.地方快讯 2.经营主体 3.供求信息 4.科技展翅 5.通知公告
       */
      btnType: '',
      /** 传递值得时候调用 */
      infoType: '',
      orgId: '',
      listData: []
    }
  },
  methods: {
    enter() {
      this.orgId = this.$route.query.orgId
      this.btn = false
      this.topitem = true
      this.citysearchBox = false
      if (this.btnType === '经营主体') {
        this.btn = true
      } else if (this.btnType === '供求信息' || this.btnType === '科技展翅') {
        this.topitem = false
        this.citysearchBox = true
      } else if (this.btnType === '地方快讯' || this.btnType === '通知公告') {
        InfoMainWebPage({ orgId: this.orgId, infoType: this.infoType }).then(res => {
        this.listData = ''
        this.listData = res.data.rows
      })
      }
    },
    ExpressBtnenter() {
      this.btnType = '地方快讯'
      this.infoType = 20
      this.enter()
    },
    BusinessBtnenter() {
      this.btnType = '经营主体'
      this.enter()
    },
    SupplBtnenter() {
      this.btnType = '供求信息'
      this.enter()
    },
    TechnologyBtnenter() {
      this.btnType = '科技展翅'
      this.enter()
    },
    NoticeBtnenter() {
      this.infoType = 3
      this.btnType = '通知公告'
      this.enter()
    },
    TextcontentClick(id) {
      this.$router.resolve({ path: 'Textcontent', query: { id } })
    }
  }
}
</script>
<style scoped>
.box{
  width: 100%;
  height: 385px;
}

.contentBox :first-child {
  margin-left: 0px;
}

.contentBox :last-child {
  margin-right: 0px;
}

.TopListbtn {
  width: 20%;
  height: 75px;
  font-weight: 800;
  font-size: 16px;
  background: #e6dfcf;
}

.TopListbtn:hover {
  background-color: #207e63;
  color: #fff;
}
.smallBtn {
  width: 115px;
  height: 40px;
}
</style>
